"use strict";

const body = document.querySelector('body');
const breadcrumbBox = document.querySelector('.breadcrumbs');
const header = document.querySelector('header.nav-bar');
const headerImg = document.querySelector('header.header-img');
const infoBox = document.querySelector('.box.info');
const toTop = document.querySelector('footer.to-top');

let end = 0;
let percent = 0;
let scrollStart = 0;
let trigger = 0;

if (infoBox) {
    trigger = (window.innerHeight / 2) + (infoBox.clientHeight / 2) + header.clientHeight;
    end = window.innerHeight + trigger;
    percent = (window.innerHeight / 100).toFixed();
}

function animateInfoBox() {
    if (headerImg && infoBox && window.innerWidth > 629) {
        if (
            window.scrollY > trigger
            && window.scrollY < end
        ) {
            let result = -1 * ((window.scrollY - trigger) / percent);
            headerImg.classList.remove('move-image');
            headerImg.setAttribute('style', 'top: ' + result + '%');
        } else if (window.scrollY > (1.5 * window.innerHeight)) {
            headerImg.classList.add('move-image');
            headerImg.setAttribute('style', 'top: -100%;');
        } else if (window.scrollY < trigger) {
            headerImg.classList.remove('move-image');
            headerImg.setAttribute('style', 'top: 0;');
        }
    } else if (headerImg && infoBox) {
        let infoBoxObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && headerImg.classList.contains('scroll-image')) {
                    headerImg.classList.remove('scroll-image');
                }
                if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
                    headerImg.classList.add('scroll-image');
                }
            });
        }, {
            threshold: 1
        });
        infoBoxObserver.observe(infoBox);
    }
}

function displayHeader() {
    if (scrollStart < window.scrollY && window.scrollY > 10) {
        header.classList.add('fade-out');
    } else {
        header.classList.remove('fade-out');
    }
    scrollStart = window.scrollY;
}

function moveContent() {
    if (headerImg && infoBox && breadcrumbBox) {
        body.classList.add('move-with-infobox');
    } else if (headerImg && breadcrumbBox) {
        body.classList.add('move-no-infobox');
    } else if (headerImg && infoBox) {
        body.classList.add('move-100');
    }
}

function showToTop() {
    if (toTop) {
        if (window.scrollY > 100) {
            toTop.classList.add('visible');
        } else {
            toTop.classList.remove('visible');
        }
    }
}

window.addEventListener('scroll', () => {
    animateInfoBox();
    displayHeader();
    showToTop();
});

window.addEventListener('resize', () => {
    moveContent();
});

moveContent();
